/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';
import StackToolIcon from 'icons/StackToolIcon';

const messages = defineMessages({
  title: {id: 'navigation.data-tools.stack'},
});

const StackItem = () => (
  <RouteLinkItem
    iconBefore={StackToolIcon}
    route="midas/data-tools/stack-tool"
    title={messages.title}
  />
);

export default StackItem;
